import { ROUTES } from './routes';

export const NAVIGATION_ITEMS = [
  { id: 1, label: 'Catalog', path: ROUTES.CATALOG },
] as const; 